import { showErrorNotify, showUserNotify } from "@/helpers/notify";

export default (adminURL, instance) => {
  return {
    removeIMG(payload) {
      return instance
        .delete(
          adminURL + "delimg",
          { data: payload },
          {
            headers: {
              "Content-type": "multipart/form-data",
            },
          }
        )
        .then(() => showUserNotify("success"))
        .catch((error) => {
          showErrorNotify(error);

          throw error;
        });
    },
  };
};
